module.exports = __webpack_public_path__ + "img/c-home-sc3-bd.f219e134.png";